import React, { Component, useState, useEffect, useCallback, useContext } from 'react';
import { TextField, DetailsList, SelectionMode,  PrimaryButton, DefaultButton } from '@fluentui/react';
import axios from 'axios';
import { authProvider } from '../authProvider';
import { AuthInfo } from '../AuthInfo';
import { AuthContext } from '../AuthContext';
const rootUrl = window.location.protocol + '//' + window.location.host + '/';

const tenantColumns = [
    { key: "column1", name: "Id", fieldName: "tenantId", minWidth: 100, maxWidth: 100, isResizable: true },
    { key: "column2", name: "Name", fieldName: "tenantName", minWidth: 600, maxWidth: 700, isResizable: true },
];
export const TenantEditor = () => {
    const authContext = useContext(AuthContext);
    const [tenants, setTenants] = useState([]);
    const [idDisabled, setIdDisabled] = useState(true);
    const [editedTenant, setEditedTenant] = useState(null);
    const onItemInvoked = (item, index) => {
        setEditedTenant(item);
        setIdDisabled(true);
    };
    useEffect(() => {
        if (tenants.length === 0 && authContext.isAuthenticated && authContext.accessToken && authContext.isAdministrator) {
            axios.get(rootUrl + "tenant", { headers: { 'Authorization': "Bearer " + authContext.accessToken }, }).then((result) => {
                setTenants(result.data);
            });
        }

    }, [authContext]);
    const onNameChange = useCallback((evt, newVal) => {
        var ten = { ...editedTenant };
        ten.tenantName = newVal;
        setEditedTenant(ten);
    }, [editedTenant, tenants]);
    const onIdChange = useCallback((evt, newVal) => {
        var ten = { ...editedTenant };
        ten.tenantId = newVal;
        setEditedTenant(ten);
    }, [editedTenant, tenants]);

    const onNewTenant = useCallback(() => {
        var newTenant = {
            tenantId: "",
            tenantName: ""
        }
        setEditedTenant(newTenant);
        setIdDisabled(false);
    }, [tenants]);
    const onSave = useCallback(() => {
        axios.post(rootUrl + "tenant", editedTenant, { headers: { 'Authorization': "Bearer " + authContext.accessToken }, }).then((res) => {
            var tens = [...tenants];
            var idx = tens.findIndex((el) => {
                return el.tenantId == res.data.tenantId;
            });
            if (idx > -1) {
                // exiting
                tens[idx] = res.data;
            } else {
                // new
                tens.push(res.data);
            }
            setTenants(tens);
            setEditedTenant(null);
        });
    }, [tenants, editedTenant]);
    const onDelete = useCallback(()=>{
        axios.delete(rootUrl + "tenant/" + editedTenant.tenantId    , {headers: {'Authorization': "Bearer " + authContext.accessToken}}).then((res)=>{
            var tens = [...tenants];
            var idx = tens.findIndex((el)=>el.tenantId == editedTenant.tenantId);
            if (idx > -1){
                tens.splice(idx, 1);
                setTenants(tens);
            }
            setEditedTenant(null);
        });
    }, [tenants, editedTenant]);

   
    return (<div>

        <h2>Manage Tenants</h2>
        {editedTenant == null &&
            <div>
                <DetailsList items={tenants}
                    columns={tenantColumns}
                    selectionMode={SelectionMode.none}
                    onItemInvoked={onItemInvoked}></DetailsList>
                <PrimaryButton onClick={onNewTenant}>Create New Tenant</PrimaryButton>
            </div>
        }
        {editedTenant != null &&
            <div>
                {<TextField label="Id" value={editedTenant.tenantId} onChange={onIdChange} disabled={idDisabled} />}
                
                <TextField label="Name" value={editedTenant.tenantName} onChange={onNameChange} />
                
                <PrimaryButton onClick={onSave}>Save</PrimaryButton>
                <DefaultButton onClick={onDelete}>Delete</DefaultButton>
                <DefaultButton onClick={() => { setEditedTenant(null); }}>Cancel</DefaultButton>

            </div>
        }

    </div>);
}

